<template>
  <div class="login-container">
    <!-- 系统 Logo 与标题 -->
    <div class="logo-wrap">
      <img src="@/assets/owl_1.svg" alt="系统图标" class="logo-icon" />
      <h1 class="system-title">猫头鹰AI视光师助理</h1>
    </div>

    <!-- 登录卡片 -->
    <el-card class="login-card" shadow="hover">
      <div slot="header" class="card-header">
        <span>视光师登录</span>
      </div>
      <el-form
        ref="loginForm"
        :model="loginForm"
        :rules="rules"
        label-width="100px"
        class="login-form"
      >
        <!-- 用户ID -->
        <el-form-item label="用户ID" prop="user_id">
          <el-input
            v-model="loginForm.user_id"
            placeholder="请输入用户ID"
            prefix-icon="el-icon-user"
          />
        </el-form-item>

        <!-- 密码 -->
        <el-form-item label="密码" prop="password">
          <el-input
            type="password"
            v-model="loginForm.password"
            placeholder="请输入密码"
            prefix-icon="el-icon-lock"
            show-password
          />
        </el-form-item>

        <!-- 按钮 -->
        <el-form-item class="btn-group">
          <el-button type="primary" @click="submitForm">登录</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>

        <el-form-item>
          <div class="to-register">
            <span>没有账户？</span>
            <el-button type="text" @click="goToRegister">立即注册</el-button>
          </div>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import CryptoJS from 'crypto-js'

export default {
  name: 'LoginView',
  data() {
    return {
      loginForm: {
        user_id: '',
        password: ''
      },
      rules: {
        user_id: [
          { required: true, message: '请输入用户ID', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    submitForm() {
      this.$refs.loginForm.validate(valid => {
        if (!valid) return;

        // 使用 SHA-256 加密密码
        const encryptedPassword = CryptoJS.SHA256(this.loginForm.password).toString();

        this.$http.post('/api/login/', {
          username: this.loginForm.user_id,  // 改为 username
          password: encryptedPassword
        }, { withCredentials: true })
        .then(response => {
          this.$message.success('登录成功');
          
          // 保存用户信息到本地存储
          const userInfo = {
            store: response.data.store || '未设置',
            optometrist: response.data.optometrist || '未设置'
          };
          localStorage.setItem('userInfo', JSON.stringify(userInfo));
          
          window.location.replace('/home');
        })
        .catch(err => {
          const msg = err.response?.data?.message || '登录失败';
          this.$message.error(msg);
        });
      });
    },
    resetForm() {
      this.$refs.loginForm.resetFields()
    },
        goToRegister() {
      this.$router.push('/register')
    }
  }
}
</script>

<style scoped>
.login-container {
  min-height: 100vh;
  padding: 20px;
  background: linear-gradient(135deg, #e0f2fe 0%, #bae6fd 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.logo-wrap {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
  background-color: rgba(255, 255, 255, 0.8);
  padding: 15px 25px;
  border-radius: 50px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.logo-icon {
  width: 48px;
  height: 48px;
  margin-right: 12px;
}

.system-title {
  color: #0369a1;
  font-size: 1.8rem;
  font-weight: bold;
}

.login-card {
  width: 400px;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #bae6fd;
  box-shadow: 0 8px 20px rgba(2, 132, 199, 0.15);
}

.card-header {
  font-size: 1.2rem;
  font-weight: 500;
  background: #f0f9ff;
  color: #0369a1;
  border-bottom: 1px solid #bae6fd;
}

.login-form {
  background-color: #ffffff;
}

.login-form .el-form-item {
  margin-bottom: 20px;
}

.btn-group {
  display: flex;
  justify-content: flex-start;
  margin-top: 10px;
  gap: 10px;
}
.btn-group .el-button {
  flex: none;
}
.el-button--primary {
  background-color: #0284c7;
  border-color: #0284c7;
}
.el-button--primary:hover {
  background-color: #0369a1;
  border-color: #0369a1;
}
</style>
